import { FIELD_TYPES } from '../../../components/ui/Form/builder/formFieldTypes';
import {
  SESSION_DAY_OPTIONS,
  SESSION_HOUR_OPTIONS,
  SESSION_MINUTE_OPTIONS,
} from '../utils/profileConstants';

export function getProfileFormSections({
  showIsStandard = false,
  organisationName = '',
  isEditMode = false,
} = {}) {
  const identityDescription = organisationName
    ? isEditMode
      ? `Update profile details for ${organisationName}.`
      : `Create a profile for ${organisationName}.`
    : isEditMode
      ? 'Profile name and session settings.'
      : 'Profile name and standard profile flag.';

  const identityFields = [
    {
      name: 'name',
      label: 'Profile Name',
      type: FIELD_TYPES.TEXT,
      required: true,
      placeholder: 'Enter profile name',
      grid: { xs: 12, md: showIsStandard ? 8 : 12 },
    },
  ];

  if (showIsStandard) {
    identityFields.push({
      name: 'is_standard',
      label: 'Is Standard',
      type: FIELD_TYPES.CUSTOM,
      hint: 'Standard profiles are reusable templates across the organisation.',
      grid: { xs: 12, md: 4 },
    });
  }

  return [
    {
      id: 'identity',
      title: 'Profile details',
      description: identityDescription,
      variant: 'card',
      fields: identityFields,
    },
    {
      id: 'session',
      title: 'Session timeout',
      description: 'Optional inactivity timeout before users are signed out.',
      variant: 'card',
      fields: [
        {
          name: 'sessionDays',
          label: 'Days',
          type: FIELD_TYPES.CUSTOM,
          grid: { xs: 12, md: 4 },
        },
        {
          name: 'sessionHours',
          label: 'Hours',
          type: FIELD_TYPES.CUSTOM,
          grid: { xs: 12, md: 4 },
        },
        {
          name: 'sessionMinutes',
          label: 'Minutes',
          type: FIELD_TYPES.CUSTOM,
          grid: { xs: 12, md: 4 },
        },
      ],
    },
  ];
}

export function getProfileFormFieldOrder(sections = getProfileFormSections()) {
  return sections.flatMap((section) => section.fields.map((field) => field.name));
}

export {
  SESSION_DAY_OPTIONS,
  SESSION_HOUR_OPTIONS,
  SESSION_MINUTE_OPTIONS,
};
